import clsx from "clsx";
import SimpleAreaChart from "../Charts/AreaChart/SimpleAreaChart/SimpleAreaChart";
import { AreaChartCardRoot } from "./AreaChartCard.styles";
import AreaChartCardHeader from "./AreaChartCardHeader";
import { SimpleAreaChartProps } from "../Charts/AreaChart/SimpleAreaChart/SimpleAreaChart.types";

export interface AreaChartCardProps extends SimpleAreaChartProps<string> {
    className?: string;
    style?: React.CSSProperties;
    title: string;
}

function AreaChartCard({ className, title, style, ...rest }: AreaChartCardProps) {
    return (
        <AreaChartCardRoot className={clsx("area-chart-card", className)} style={style}>
            <AreaChartCardHeader title={title} />
            <SimpleAreaChart {...rest} />
        </AreaChartCardRoot>
    );
}

export default AreaChartCard;
